const IconMapping = {
	'send_email': 'roundedSquareMail'
}

export {
	IconMapping
}